import React from 'react'
import R from 'ramda'
import { connect } from 'react-redux'
import { getGroups, getSelectedGroups } from '../selectors'
import * as actions from '../actions'
import { Select } from 'antd'

const toOptions = R.compose(
  R.sortBy(R.compose(R.toLower, R.prop('value'))),
  R.map(([group, _]) => ({
    key: group,
    value: group,
    text: group,
  })),
  // group=>R.sort(,group),
  // R.map(([group, _])=>group,
  R.toPairs
)

const computeSelectedGroups = (groups, multiple) =>
  multiple && typeof groups === 'string'
    ? [groups]
    : multiple && groups === 'all'
    ? []
    : !multiple && Array.isArray(groups)
    ? groups[0]
    : groups

const GroupSelector = ({
  fluid,
  multiple,
  groups,
  selectedGroups,
  selectGroups,
  disabled,
  className,
  style = {},
  allowAll,
}) => (
  <div style={{ zIndex: '1000' }}>
    <Select
      mode={multiple ? 'multiple' : 'default'}
      className={className}
      style={{ ...style, width: fluid ? '100%' : '200px' }}
      placeholder="Select Group"
      // multiple={multiple}
      // search
      // selection
      // fluid={fluid}
      disabled={disabled}
      // options={
      //   allowAll
      //     ? [
      //         { key: 'all', value: 'all', text: 'All Units' },
      //         ...toOptions(groups),
      //       ]
      //     : toOptions(groups)
      // }
      onChange={value =>
        selectGroups(typeof value === 'string' ? [value] : value)
      }
      value={computeSelectedGroups(selectedGroups, multiple)}
    >
      {allowAll && (
        <Select.Option key="all" value="all">
          All Units
        </Select.Option>
      )}
      {toOptions(groups).map(d => (
        <Select.Option key={d.key} value={d.value}>
          {d.text}
        </Select.Option>
      ))}
    </Select>
  </div>
)
const mapStateToProps = state => ({
  groups: getGroups(state),
  selectedGroups: getSelectedGroups(state),
})

export { GroupSelector }

export default connect(mapStateToProps, actions)(GroupSelector)
